import React, {Fragment, useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, Row, Col, Form} from 'react-bootstrap'

import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import {Link, Route, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {updateValues} from "../../../actions/BasicActions";
import {getHospital} from "../../../actions";

const HospitalData = ({getHospital, Basic: {hospital}}) => {
    useEffect(() => {
        getHospital();
    }, []);
    return (

        <Form>

            {hospital ? Object.keys(hospital).map(item =>
                    <Form.Group key={item} controlId={item}>
                        <Form.Label>{item}</Form.Label>
                        <Form.Control type="text" readOnly={true} value={hospital[item] ? hospital[item] : ''}
                        />
                    </Form.Group>
                ) :
                <></>
            }

        </Form>

    )
};
const style = {
    borderLeft: '1px solid rgba(0,0,0,.125)',
    borderRight: '0px',
    borderBottom: '0px',
}
const mapStateToProps = state => ({
    Basic: state.Basic,
    PlotData: state.PlotData

});
export default connect(mapStateToProps, {getHospital})(HospitalData)